export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sys/cms/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sys/cms/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sys/cms/save`,
                data
            })
        },



        delete(data) {
            return http.json({
                url: `/sys/cms/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/sys/cms/updateState`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/cms.js